import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import StageList from './StageList';
import Button from '@mui/material/Button';
import AddToPhotosOutlinedIcon from '@mui/icons-material/AddToPhotosOutlined';
import { useDispatch, useSelector } from 'react-redux';
import {
  get_company_process,
  get_company_process_stage,
  setCompany,
  setProcessHasJobForm,
  setProcessTab,
  setStageTab
} from '../../../store/user/userSlice';
import { isAuth } from '../../../helpers/cookies';
import IconButton from '@mui/material/IconButton';
import Search from '../home/Search';
import { useNavigate } from 'react-router-dom';
import { setJobData } from '../../../store/job/jobSlice';
// import { clearJobData } from '../../../store/job/jobSlice';

const ProcessList = (props) => {
  const {
    company_process,
    company_process_stage,
    selected_process_tab,
    selected_stage_tab,
    selected_company,
    ChildComponent
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_company, is_job_form } = useSelector((state) => state.user);

  const handleProcessTabChange = (event, newValue) => {
    let company_id = selected_company ? selected_company : isAuth().company_id;

    if (!company_id) {
      const proc = company_process.find(p => p.id === newValue);
      if (proc?.company_id) company_id = proc.company_id;
    }

    if (company_id) {
      let params = {
        company_id,
        process_id: newValue
      }
      dispatch(get_company_process_stage(params));
    }

    dispatch(setProcessTab(newValue));
    dispatch(setProcessHasJobForm(newValue));
    dispatch(setJobData({}));

    const selectedProcess = company_process.find(p => p.id === newValue);
    if (selectedProcess && selectedProcess.stage && selectedProcess.stage.length > 0) {
      dispatch(setStageTab(selectedProcess.stage[0].id));
    } else {
      dispatch(setStageTab(null));
    }
  };

  const handleSearchSubmit = () => {
    if (window.location.pathname !== "/") {
      navigate("/");
    }
  };
  useEffect(() => {
    if (company_process.length > 0) {
      const isCurrentSelectionValid = selected_process_tab && company_process.some(p => p.id === selected_process_tab);

      if (isCurrentSelectionValid) {
        let company_id = selected_company ? selected_company : isAuth().company_id;
        if (!company_id) {
          const proc = company_process.find(p => p.id === selected_process_tab);
          if (proc?.company_id) company_id = proc.company_id;
        }

        if (company_id) {
          // Check if these stages were already loaded for THIS process
          if (company_process_stage.length === 0 || !isCurrentSelectionValid) {
            dispatch(get_company_process_stage({ company_id, process_id: selected_process_tab }));
          }
          dispatch(setProcessHasJobForm(selected_process_tab));
        }
        return;
      }

      // Defaulting logic
      let process_id = company_process[0].id;
      let company_id = selected_company || isAuth().company_id || company_process[0]?.company_id;

      if (company_id && process_id) {
        dispatch(get_company_process_stage({ company_id, process_id }));
        dispatch(setProcessHasJobForm(process_id));
        dispatch(setProcessTab(process_id));
        if (company_process[0].stage && company_process[0].stage.length > 0) {
          dispatch(setStageTab(company_process[0].stage[0].id));
        }
      }
      dispatch(setJobData({}));
    }
  }, [company_process.length, selected_process_tab, selected_company]);

  const handleCompanyChange = (event) => {
    const { value } = event.target;
    let company_id = value ? value : isAuth().company_id;
    dispatch(setCompany(value));
    dispatch(get_company_process(company_id));
  };

  // const handleClearCompany = (event) => {
  //   const company_id_reset = "";
  //   dispatch(clearJobData());
  //   navigate('/');
  //   const {value} = event.target;
  //   let company_id = value ? value : isAuth().company_id;    
  //   dispatch(setCompany(company_id_reset));
  //   dispatch(get_company_process(company_id));
  // };  

  const processesWithStages = company_process.filter(p => p.stage.length > 0);
  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      {
        (company_process.length && selected_process_tab) > 0 &&
        (
          <TabContext value={selected_process_tab}>
            <Stack
              display="flex"
              alignItems="center"
              sx={{
                flexDirection: { md: 'row', xs: 'column' }
              }}
            >

            </Stack>
            <Box sx={{
              "& .MuiTabPanel-root": {
                background: 'linear-gradient(#FFFFF 0%, #f5ad8bff 100%)',
                width: '100%',
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
                borderBottomRightRadius: "10px",
                padding: "0px",
              }
            }}>
              {
                company_process.filter(p => p.id === selected_process_tab).map((process, idx) => {
                  return (
                    <TabPanel value={process.id} key={idx} sx={{
                      padding: '0px'
                    }}>
                      <StageList
                        company_process_stage={company_process_stage}
                        selected_stage_tab={selected_stage_tab}
                        selected_process_tab={selected_process_tab}
                        ChildComponent={ChildComponent}
                      />
                    </TabPanel>
                  )
                })
              }
            </Box>
          </TabContext>
        )
      }
    </Box>
  )
}

export default ProcessList;